import React, { FC, PropsWithChildren } from 'react';
import { useTheme } from 'styled-components';

import { ThemeMode } from '@/helpers/enums';
import { ValidatorMessage } from '@/helpers/validators';

import { ScInputStructure } from './styled';

export interface InputStructureProps extends PropsWithChildren {
  error?: React.ReactNode;
  hideInputErrorColor?: boolean;
  disabled?: boolean;
  hideErrorMessage?: boolean;
  infoMessage?: string | JSX.Element;
  addons?: JSX.Element;
  withTick?: boolean;
  mode?: ThemeMode;
  background?: string;
  setInputRightPadding?: (arg: number) => void;
  preventValidation?: boolean;
  mask?: (value: string) => void;
  validatorWarning?: (value: string) => void | ValidatorMessage;
}

export const InputStructure: FC<InputStructureProps> = ({
  setInputRightPadding,
  error,
  hideErrorMessage = false,
  infoMessage,
  children,
  addons,
  withTick,
  ...props
}) => {
  const { images } = useTheme();

  return (
    <ScInputStructure {...props}>
      <div className="content">
        {children}
        {(addons || withTick) && (
          <div
            className="addons"
            ref={(node) => {
              if (!node || !setInputRightPadding) return;
              setInputRightPadding(node.clientWidth + 8);
            }}
          >
            {withTick &&
              (error ? (
                <images.tickCircleDeclineIcon.component />
              ) : (
                <images.tickCircleIcon.component />
              ))}

            {addons}
          </div>
        )}
      </div>
      {!hideErrorMessage && error != null && error !== '' ? (
        <div className="error">{error}</div>
      ) : (
        infoMessage && <div className="info">{infoMessage}</div>
      )}
    </ScInputStructure>
  );
};
